import type { ProxyItem } from '../types';

export const buildProxyConfigLine = (proxy: ProxyItem, resolvedIP: string): string =>
  [
    resolvedIP,
    String(proxy.port),
    proxy.username,
    proxy.password,
    (proxy.expire_at || '').slice(0, 10),
  ].join('|');

export const buildBatchProxyConfigText = (
  proxies: ProxyItem[],
  resolvedIPs: ReadonlyMap<number, string>,
): string => proxies.map((proxy) => {
  const resolvedIP = resolvedIPs.get(proxy.node_id);
  if (!resolvedIP) {
    throw new Error(`节点 ${proxy.node_name || proxy.node_id} 缺少解析地址`);
  }
  return buildProxyConfigLine(proxy, resolvedIP);
}).join('\n');
